import { initMap, equalCols } from '../functions';
import Swal from 'sweetalert2'

$.fn.isInViewport = function() {
	var elementTop = $(this).offset().top;
	var elementBottom = elementTop + $(this).outerHeight();

	var viewportTop = $(window).scrollTop();
	var viewportBottom = viewportTop + $(window).height();

	return elementBottom > viewportTop && elementTop < viewportBottom;
};

$(document).ready(function() {

	$('.select2').select2();

	$('.date-picker').datepicker({
        autoclose: true
    });
	
    // $('.hamburger').click(function(e) {
    //     e.preventDefault()
    //     $(this).toggleClass('is-active');
    // });

	/* A jQuery function that is toggling the class active on the element with the class submenu-btn. */
	$(".submenu-btn").on('click', function(e) {
		e.preventDefault();
		$(this).toggleClass('active');
		$(this).siblings('.drop-list').slideToggle();
	});
	$(".has-submenu").on('click', function(e) {
		e.preventDefault();
		$(this).parent().find('.submenu-btn').toggleClass('active');
		$(this).parent().find('.submenu-btn').siblings('.drop-list').slideToggle();
	});

	/* This is a jQuery function that is adding the class active to the header element when the user
	scrolls down more than 50px. */
	$(window).scroll(function(){
		if ($(this).scrollTop() > 50) {
		   $('header').addClass('active');
		} else {
		   $('header').removeClass('active');
		}
	});

	/* Adding the class active to the parent element of the element with the class active. */
	$(".drop-list ul").each(function (index, element) {
		let elements = $(element).children('li').children();
		let activeParent = $(this).parent('.drop-list').siblings('.has-submenu');

		if(elements.hasClass("active")) {
			activeParent.addClass('active');
		}
	});

	const navLinks = document.querySelectorAll('.offcanvas-body .nav-item')
	const bsOffcanvas = new bootstrap.Offcanvas('#mobile-menu')
	navLinks.forEach((l) => {l.addEventListener('click', () => { 
		bsOffcanvas.toggle();
	})
	})
	if ($(window).width() > 1200) {
		const scrollSpy = new bootstrap.ScrollSpy(document.body, {
			target: '#navbar-header',
		})
	 }
	else {
		const scrollSpy = new bootstrap.ScrollSpy(document.body, {
			target: '#mobile-menu',
		})
	}

});



// WEBPACK FOOTER //
// ./resources/assets/js/regular/general.js